import { AssetAccessLevel, AssetCategory } from "./asset";

export class AssetFolder {
  folder_id: string = "";
  eva_company_id: string = "";
  name: string = "";
  parent_folder_id: string = null;
  path: string = "";
  depth: number = 0;
  category: AssetCategory = null;
  category_object_id: string = null;
  access_level: AssetAccessLevel = AssetAccessLevel.ALL;
  tags: string[] = [];
  created_at: Date = null;
  created_by: string = "";
  created_by_name: string = "";

  public static createInstance(jsonData: any): AssetFolder {
    const f = Object.assign(new AssetFolder(), jsonData);
    f.parent_folder_id = f.parent_folder_id ?? null;
    f.category = f.category ?? null;
    f.category_object_id = f.category_object_id ?? null;
    f.tags = Array.isArray(f.tags) ? f.tags : [];
    return f;
  }

  public static createInstances(jsonData: any[]): AssetFolder[] {
    return jsonData.map(AssetFolder.createInstance);
  }
}
